// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"658":"31cbb265","778":"effd9439"}[chunkId] + ".chunk.js";
};